var default_styles_default = {
  "button_container": "jYxzO",
  "button_text": "zf3-D",
  "button_size_content": "-rnV-"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
